export const gitCommit = 'ab0fe64a'
